<template>
  <b-card :title="$t('settings.widget.referral_link')">
    <form ref="form" @submit.prevent="saveReferralLink">
      <b-row>
        <b-col>
          <b-form-group :label="$t('settings.widget.referral_link')">
            <b-form-input v-model="referralLink"></b-form-input>
          </b-form-group>

          <b-button type="submit" variant="primary">
            {{ $t('general.save') }}
          </b-button>
          <b-button class="ml-2" type="button" variant="light" @click="resetReferralLink()">
            {{ $t('settings.widget.reset') }}
          </b-button>

        </b-col>
        <b-col>
          <b-row v-show="referralLink">
            <b-col>
              <b-img
                :src="referralQRCode" thumbnail left fluid height="150" width="150"
                alt="referral link qr code">
              </b-img>
            </b-col>
          </b-row>
          <b-row v-show="referralLink">
            <b-col>
              <b-button class="mt-3" variant="primary" :href="referralQRCode" download="download">
                Download QR Code
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </form>
  </b-card>
</template>

<script>
import {FormMixin} from 'stylemix-base'
import AdminStore from "../../../console/src/stylemix-vue-admin/store";

export default {
  name: 'ReferralLinkForm',

  mixins: [FormMixin],

  data() {
    return {
      referralLink: null,
      referralQRCode: null,
    }
  },

  watch: {
    '$account': {
      handler(newVal) {
        if (newVal) {
          this.setReferralLink();
        }
      },
      immediate: true
    }
  },

  methods: {
    setReferralLink() {
      if (this.$account) {
        this.referralLink = this.$account.referral_link
        this.referralQRCode = this.$account.referral_qrcode

        if (!this.referralLink) {
          this.saveReferralLink();
        }
      }
    },

    saveReferralLink() {
      const promise = this.$http
        .post('/users/' + this.$account.id + '/update-referral-link', {referral_link: this.referralLink})
        .then(response => {
          this.referralLink = response.data.referral_link
          this.referralQRCode = response.data.referral_qrcode

          // refresh global $account store
          AdminStore.dispatch('admin-auth/find')

          this.$toast.success(response.data.message);
        })
        .catch(err => this.$toast.error(err.response.data.message))

      this.$uiBlocker(promise, this.$el)
    },
    resetReferralLink() {
      const promise = this.$http
        .get('/users/' + this.$account.id + '/reset-referral-link')
        .then(response => {
          this.referralLink = response.data.referral_link
          this.referralQRCode = response.data.referral_qrcode

          // refresh global $account store
          AdminStore.dispatch('admin-auth/find')

          this.$toast.success(response.data.message);
        })
        .catch(err => this.$toast.error(err.response.data.message))

      this.$uiBlocker(promise, this.$el)
    },
  },
}
</script>

<style scoped></style>
